import { useEffect, useState } from "react"
import { AttentionServiceCardTree } from "../QuickTurnStart/Componentes/SelectAttentionCardService/AttentionServiceCardTree/AttentionServiceCardTree"
import { PrintJson } from "../../../../../../modules/theme/Component/PrintJson";
import { RenderForm } from "../../../../../../modules/theme/Component/RenderForm";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AttentionTicket } from "../../../../../../core/services/dataBean/QuickEntityCatalog";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../../modules/theme/Component/hooks/useModal";
import { QuickTurnSelectCustomerType } from "../QuickTurnStart/Componentes/QuickTurnSelectCustomerType";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../modules/theme/Component/Modal";
import { CustomFormsQuickTurn } from "./CustomFormsQuickTurn/CustomFormsQuickTurn";

export const QuickTurnExecute = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AttentionTicket);

    const [urlDoc, setUrlDoc] = useState<string>("");
    const [form, setForm] = useState<any>({});
    const [ticket, setTicket] = useState<any>({});

    const modalUse = useModal("", MODAL_md);
    const modalResponse = useModal("", MODAL_LG);
    const modalPDF = useModal(`Documento generado`, MODAL_LG);

    useEffect(() => {

        // if (bean.ActionType === 15 && bean.IDLn) {
        //     console.log("imprimir")
        // }

        if (bean.ActionType === 16) {
            if (bean.RequestForm) {
                modalUse.open(`${bean.FormName}`);
                return;
            }
            if (bean.SendDocumentToPrinter) {
                createTicket(
                    (e) => {
                        setTicket(e)
                        executeService(e.IDTicket)
                    }
                );
            }
        }

        //revisar servicios en el inspector del kiosko

        if (bean.ActionType === 19 && bean.IDLn) {
            console.warn('url para redireccionar', bean.URLRequest);
            window.open(bean.URLRequest, '_blank');
        }
    }, [bean.IDLn])


    const createTicket = (execute: (resp: any) => void) => {
        instance.getAttentionTicket6(bean.IDCustomerType, bean.IDLn, null, _single.getAccount().Nit, null, null).then((resp) => {
            if (resp?.IDTicket) {
                execute(resp);
            } else {
                toast.error("No se generó el turno correctamente");
            }
        })
            .catch(() => {
                toast.error("Error al generar el turno servicio");
            });
    };

    const responseIDTicket = () => {
        const data = { ...form, id: _single.getAccount().Nit }
        createTicket((e) => {
            instance.responseAttentionTicketForm(e.IDTicket, data, false).then(
                (resp) => {
                    console.log(resp)
                    if (resp.DocumentURL) {
                        setUrlDoc(resp.DocumentURL)
                    }
                    if (resp.InvokedRVJsonValue) {
                        let x = resp.InvokedRVJsonValue ? JSON.parse(resp.InvokedRVJsonValue) : {};
                        toast.info(x.errorDescription)
                    }
                    modalUse.close();
                }
            ).catch(err => { toast.error("Error al enviar el formulario") })
        })
    }


    const executeService = (idTicket: number) => {
        instance.parseForInvokeJsonServiceFromAttentionTicket(idTicket).then(
            (resp) => {
                if (resp.ErrorMessage) {
                    toast.error(resp.ErrorMessage);
                }
                if (resp.Response) {

                    if (bean.URLForDocumentRequest + resp.Response.reporte) {
                        toast.info("Reporte Generado")
                        setUrlDoc(bean.URLForDocumentRequest + resp.Response.reporte);
                    }
                    if (resp.Response.tramites.length > 0) {
                        setForm(resp.Response)
                    }
                    if (resp.Response.errorDescription) {
                        toast.info(resp.Response.errorDescription)
                    }
                    if (bean.ShowResponseForm) modalResponse.open(`${bean.FormName}`);
                }
            }
        ).catch(resp => {
            console.log(resp)
        })
    }

    useEffect(() => {
        if (urlDoc) {
            modalPDF.open();
        }
    }, [urlDoc])

    return (
        <div className="row">
            <div className="col-md-12 mt-2">
                <AttentionServiceCardTree idAttentionPoint={42} onSelect={(e) => { setBean({ ...bean, ...e }) }} />

                <Modal modal={modalUse.modal} updateModal={modalUse.setModal} eventModal={() => { responseIDTicket() }} >
                    <CustomFormsQuickTurn objectData={form} FormType={bean.FormCode} onChange={setForm} />
                </Modal>

                <Modal modal={modalResponse.modal} updateModal={modalResponse.setModal} >
                    <CustomFormsQuickTurn objectData={form} FormType={bean.FormCode} />
                </Modal>

                <Modal modal={modalPDF.modal} updateModal={modalPDF.setModal} evenOnClose={() => { setBean({}); setUrlDoc(""); }} >
                    <a href={urlDoc} target="blank" >{urlDoc}</a>
                </Modal>
                {/* <PrintJson json={bean} /> */}
            </div >
        </div >
    )
}